module.exports = __webpack_public_path__ + "img/TRASH.56974337.svg";